import { createAction, props } from '@ngrx/store';
import { FuelEntries, FuelEntry } from '../models/fuel.model';

export const loadFuelEntries = createAction(
  '[Fuel] Load Fuel Entries',
  props<{ vanId: string }>()
);

export const loadFuelEntriesSuccess = createAction(
  '[Fuel] Load Fuel Entries Success',
  props<{ data: FuelEntries | null }>()
);

export const loadFuelEntriesFailure = createAction(
  '[Fuel] Load Fuel Entries Failure',
  props<{ error: string }>()
);

export const saveFuelEntries = createAction(
  '[Fuel] Save Fuel Entries',
  props<{ vanId: string; entries: FuelEntry[] }>()
);

export const saveFuelEntriesSuccess = createAction(
  '[Fuel] Save Fuel Entries Success',
  props<{ vanId: string }>()
);

export const saveFuelEntriesFailure = createAction(
  '[Fuel] Save Fuel Entries Failure',
  props<{ error: string }>()
);
